import { TableSortOption } from '@evinced-private/ui-common';

import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';

import { buildUniqueIssuesVariables } from '../queries/unique-issues/helpers/buildVariables';
import {
	IUniqueIssuesResult,
	transformUniqueIssuesResults
} from '../queries/unique-issues/helpers/transformResults';
import { GetUniqueIssuesQuery } from '../queries/unique-issues/UniqueIssues.generated';
import { GetUniqueIssues } from '../queries/unique-issues/UniqueIssues.gql';

interface IGetUniqueIssuesParams {
	filters: IFilterOptions;
	page: number;
	sizePerPage: number;
	sort?: TableSortOption;
}

export const getUniqueIssues = async ({
	filters,
	page,
	sizePerPage,
	sort
}: IGetUniqueIssuesParams): Promise<IUniqueIssuesResult> => {
	try {
		const variables = buildUniqueIssuesVariables(filters, page, sizePerPage, sort);

		const result = await gqlClient.request<GetUniqueIssuesQuery>(GetUniqueIssues, variables);

		return transformUniqueIssuesResults(result);
	} catch (e) {
		Logger.error('UniqueIssuesService -> getUniqueIssues failed:', e);
		throw e;
	}
};
